<template>
    <div class="singleVideo">
        <div class="add-wrap">
            <div class="defaultImg">
                <p class="add"><i class="el-icon-upload2"></i></p>
                <p>点击此处上传视频</p>
                <p class="tips">支持扩展名： .mp4</p>
            </div>
            <input type="file"
                   class="file"
                   @change="addChangeVideo"
                   ref="inputImg"
                   accept="video/mp4">
            <div v-if="isUpload">
                <div class="inline-left">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconhuabanfuben1"></use>
                    </svg>
                    <p>{{videoName}}</p>
                </div>
                <el-progress :percentage="progress"/>
            </div>
        </div>
        <div class="video" v-if="videoFile">
            <video :src="videoFile" controls="controls" v-if="videoFile!==''"></video>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        name: 'single-video',
        props: {
            file: {
                type: String
            },
            fileType: {
                type: String,
                default: '1'
            }
        },
        data() {
            return {
                isUpload: false, // 正在上传
                videoName: '',
                defaultImg: this.$Public.defaultImg,
                videoFile: this.file,
                progress: 0
            };
        },
        created() {
        },
        methods: {
            addChangeVideo(e) {
                // 上传视频
                this.upFile(e, res => {
                    this.videoFile = res;
                    this.$emit('getFile', res);
                    this.$refs.inputImg.value = '';
                    setTimeout(() => {
                        this.isUpload = false;
                    }, 1000);
                });
            },
            upFile(e, fun) {
                // 上传文件
                this.progress = 0;
                let file = e.target.files[0];
                this.videoName = e.target.files[0].name;
                if (!file) {
                    return;
                }
                let time = setInterval(() => {
                    this.progress += 1;
                    // console.log(1111, this.progress);
                    if (this.progress >= 98) {
                        clearTimeout(time);
                    }
                }, Math.random()*2000);
                this.isUpload = true;
                this.httpUploadImg({ type: this.fileType, file: file }).then(res => {
                    clearTimeout(time);
                    this.progress = 100;
                    fun(res);
                }, (res) => {
                });
            }
        },
        watch: {
            file(val) {
                this.videoFile = val;
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';
    .el-icon-upload2 {
        color: blue
    }
    .inline-left{
        margin-top 30px
        .icon{
            width:16px
            height:16px
            fill:gary9
            margin-right 10px
        }
    }
    .singleVideo {
        flex-x(flex-start, flex-start)
        .add-wrap {
            position relative
            width: 300px
            height: 150px
            background grayF6
            border: 1px dashed gray9
            .defaultImg {
                width: 300px
                height: 150px
                .add {
                    font-size 30px
                }
                flex-y(center, center);
                p {
                    text-align center
                }
            }
        }
        .edit-wrap {
            position relative
            img {
                width: 100%
                height: 100%
            }
        }
        input {
            width: 100%
            height: 100%
            opacity 0
            position absolute
            top: 0
            left: 0
        }
    }

    .video {
        width: 900px
        height: 700px
        margin-left 120px
        video {
            width:900px
        }
    }

    p {
        float: left;
    }
</style>
